module.exports = __webpack_public_path__ + "static/media/engineering.2989bc50.webp";